import { NodeKey, $getNodeByKey } from 'lexical';
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { InlineFrameNode } from '../nodes/InlineFrameNode';
import { Size } from '../../../lib/Graphics/Dim2';
import EmbeddedMedia from './EmbeddedMedia';

export type InlineFrameProperties =
{
    src: string
    width?: number
    height?: number
    title?: string
    allow?: string
    sandbox?: string
    referrerPolicy?: string
    loading?: string
    allowFullScreen?: string
}

function normalizeSrc(src: string)
{
    if (src)
    {
        const url = new URL(src);
        if (url.hostname.toUpperCase().includes('YOUTUBE.COM') && url.pathname.toUpperCase() === '/WATCH')
        {
            return `${url.origin}/embed/${url.searchParams.get('v')}`;
        }
    }
}

export function InlineFrame({ nodeKey, properties }: { nodeKey: NodeKey; properties?: InlineFrameProperties })
{
    const [editor] = useLexicalComposerContext();
    const initialSize: Size | null = properties?.width && properties?.height
        ? { width: properties.width, height: properties.height }
        : null;
    const src = properties?.src ? normalizeSrc(properties.src) : '';
    const handleResizeEnd = (width: number, height: number) =>
    {
        editor.update(() =>
        {
            const node = $getNodeByKey(nodeKey) as InlineFrameNode | null;
            if (node) { node.setSize(width, height); }
        });
    };
    const element =
    <EmbeddedMedia
        nodeKey={nodeKey}
        initialSize={initialSize}
        onSizeCommit={handleResizeEnd}
    >
    {({ mediaRef, style }) => (
        <iframe
            ref={mediaRef as any}
            src={src}
            allow={properties?.allow || 'encrypted-media'}
            allowFullScreen={Boolean(properties?.allowFullScreen)}
            title={properties?.title}
            loading={properties?.loading as any}
            referrerPolicy={properties?.referrerPolicy as any}
            sandbox={properties?.sandbox}
            style={style}
        />
    )}
    </EmbeddedMedia>;
    return element;
}

// export function InlineFrame({ nodeKey, properties }: { nodeKey: NodeKey; properties?: InlineFrameProperties })
// {
//     const initialSize = (properties?.width && properties?.height) ? { width: properties.width, height: properties.height } : null;
//     const containerRef = useRef<HTMLDivElement>(null);
//     const backdropRef = useRef<HTMLIFrameElement>(null);
//     const frameRef = useRef<HTMLIFrameElement>(null);
//     const [editor] = useLexicalComposerContext();
//     const [isSelected, setIsSelected, clearSelection] = useLexicalNodeSelection(nodeKey);
//     const [isResizing, setIsResizing] = useState(false);
//     const [size, setSize] = useState<Dim2.Size | null>(initialSize);
//     const [selection, setSelection] = useState<BaseSelection | null>(null);
//     const isFocused = $isNodeSelection(selection) && (isSelected || isResizing);
//     useEffect(() =>
//     {
//         const editorUpdate = editor.registerUpdateListener(({ editorState }) => { setSelection(editorState.read(() => $getSelection())); });
//         const click = editor.registerCommand<MouseEvent>
//         (
//             CLICK_COMMAND,
//             (event: MouseEvent) =>
//             {
//                     if (isResizing) { return true; }
//                     if ((event.target as HTMLElement)?.parentElement === backdropRef.current?.parentElement)
//                     {
//                         if (!event.shiftKey) { clearSelection(); }
//                         setIsSelected(!isSelected);
//                         return true;
//                     }
//                     return false;
//             },
//             COMMAND_PRIORITY_LOW
//         );
//         return mergeRegister(editorUpdate, click);
//     },
//     [editor, isResizing]);
//     const handleResizeStart = () =>
//     {
//         if (frameRef.current)
//         {
//             // lepsze niż display:none – nie zmienia layoutu:
//             frameRef.current.style.visibility = 'hidden';
//             frameRef.current.style.pointerEvents = 'none';
//         }
//         setIsResizing(true);
//     };
//     const handleResizeEnd = (width: number, height: number) =>
//     {
//         // setTimeout(() => setIsResizing(false), 200);
//         setIsResizing(false);
//         setSize({ width, height });
//         if (frameRef.current)
//         {
//             frameRef.current.style.visibility = 'visible';
//         }
//         editor.update(() =>
//         {
//             const node = $getNodeByKey(nodeKey) as InlineFrameNode | null;
//             if (node) { node.setSize(width, height); }
//         });
//     };

//     const src = properties?.src ? normalizeSrc(properties.src) : '';
//     // const style = { pointerEvents: 'none' as any, height: size?.height, width: size?.width };
//     const containerStyle: React.CSSProperties =
//     {
//         position: 'relative',
//         width: size?.width,
//         height: size?.height,
//         display: 'inline-block',
//     };
//     const iframeStyle: React.CSSProperties =
//     {
//         width: '100%',
//         height: '100%',
//         pointerEvents: 'none',
//         display: 'block',
//     };
//     const backdropClassName = isFocused ? 'backdrop-focused' : 'backdrop';
//     const element =
//     <Suspense fallback={null}>
//         <div draggable={isSelected && $isNodeSelection(selection)} ref={containerRef} style={containerStyle}>
//             <iframe ref={frameRef} src={src} allow="encrypted-media" allowFullScreen style={iframeStyle} />
//             <div ref={backdropRef} onClick={() => setIsSelected(!isSelected)} className={backdropClassName} />
//             {
//                 isFocused &&
//                 <ImageResizer
//                     showCaption={false}
//                     setShowCaption={() => {}}
//                     editor={editor}
//                     targetRef={containerRef}
//                     onResizeStart={handleResizeStart}
//                     onResizeEnd={handleResizeEnd}
//                 />
//             }
//         </div>
//     </Suspense>;
//     return element;
// }